import { useMemo } from 'react'

import { useMe } from '@/shared/auth/queries'

import { ROLES } from '../constants'

/**
 * Returns the list of tenants the current user has the Admin role on.
 * Single source of truth for admin-gated tenant selectors
 * (Member Of, Access To, tenant filter on the members table).
 */
export const useAdminTenants = () => {
	const { data } = useMe()

	return useMemo(() => {
		return data.allowed_tenants.filter(
			(tenant) => data.tenant_roles[tenant.id] === ROLES.Admin,
		)
	}, [data.allowed_tenants, data.tenant_roles])
}
